/*!
 * ================================================================
 * Project: Neo Admin
 * Author: César R.
 * Email: cesar.rcbx@gmail.com
 * ================================================================
 */

// Vendors Core
//-----------------------------------------------------------------
import "bootstrap";


/**!
 * PLUGINS
 */
/* ---------------------------------------------------------------- */
// Vendors Plugins
//-----------------------------------------------------------------
import swal from 'sweetalert2';
window.Swal = swal;

import "chart.js";



// Apps
//-----------------------------------------------------------------
import "./neoadmin/general.js";

